
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/women-category/[category]",
      function () {
        return require("private-next-pages/women-category/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/women-category/[category]"])
      });
    }
  